const canViewFiles = organization => (organization && organization.plan.can_access_files) || !organization
const canViewRequests = organization => organization && organization.plan.can_access_festivals

const getAvailableNotifications = (user, organization) =>
  [
    {
      type: "Account & Security",
      description: "Notify me about:",
      show: true,
      rows: [
        {
          key: "security",
          flag: "device_access",
          text: "Login alerts",
          description: "Get notified when your account is accessed from a new or unrecognized device or location."
        },
        {
          key: "security",
          flag: "log_in_credential_updates",
          text: "Security changes",
          disabled: true,
          description: "Confirmation emails when important security settings change, such as your password or 2FA."
        },
        {
          key: "security",
          flag: "password_attempts",
          text: "Suspicious activity alerts",
          disabled: true,
          description: "We'll notify you immediately if we detect unusual or potentially compromised account activity."
        }
      ]
    },
    {
      type: "Billing & Payments",
      show: canViewFiles(organization) && organization.is_enterprise !== true,
      rows: [
        {
          key: "account",
          flag: "payment_updates",
          text: "Payment receipts",
          disabled: true,
          description: "Receipts or invoices for subscriptions and other purchases."
        },
        {
          key: "account",
          flag: "payment_failures",
          text: "Failed payment notices",
          disabled: true,
          description: "We'll let you know if your primary payment method is about to expire."
        },
        {
          key: "account",
          flag: "plan_updates",
          text: "Subscription updates",
          disabled: true,
          description: "Important changes to your subscription, like cancellation confirmations or service suspension warnings."
        },
      ],
    },
    {
      type: "Usage",
      show: canViewFiles(organization),
      rows: [
        {
          key: "account",
          flag: "storage_space",
          text: "Storage space alerts",
          description: "Get notified when you're running low on available storage."
        },
        {
          key: "projects",
          flag: "file_requests",
          text: "File submission alerts",
          description: "When someone uploads files to a request you've sent."
        },
        {
          key: "screeners_and_screener_rooms",
          flag: "screener_ready_alerts",
          text: "Screener ready alerts",
          description: "We'll let you know when your screener has finished processing and is ready to share."
        }
      ]
    },
    {
      type: "Requests & Submissions",
      show: canViewRequests(organization),
      rows: [
        {
          key: "festivals",
          flag: "submissions",
          text: "Submissions",
          description: "When submissions are provided to requests."
        }
      ]
    }
  ].filter(opt => opt.show)

export default getAvailableNotifications
